export default {"src":"/_next/static/media/Opthalmology.7de00130.svg","height":91,"width":90,"blurWidth":0,"blurHeight":0};